const projects = [
  {
    title: 'Microservices for STM & TomTom Data Integration',
    description: 'Developed a microservice architecture to compare travel times.',
    technologies: 'Python, Kafka, Microservices',
  },
  {
    title: 'TBrain Competition: Go Power Imitation',
    description: 'Built machine learning networks for Go game imitation.',
    technologies: 'CNN, RNN, LSTM',
  },
  {
    title: 'Document Similarity Detection using LSH and MapReduce on Apache Spark',
    description: 'Finding similar documents using LSH with MapReduce on multi-node Spark Cluster',
    technologies: 'Apache Spark, MapReduce, LSH, Hadoop, Python, Scala',
  },
];

module.exports = { projects };
